import React from "react";
import { IonButton, IonIcon, IonLabel, isPlatform } from "@ionic/react";
import "../../global.scss";
import {
  LOGIN_OR_SIGNUP,
  ENTER_SIX_DIGIT_OTP,
  RESEND_OTP_IN,
  CONTINUE,
  SUBMIT,
  REENTER_MOBILE_NO,
  OTP_HAS_BEEN_SENT,
  RESEND_OTP,
  PLEASE_ENTER_VALID_OTP_NUMBER,
} from "../../constants";
import { connect } from "react-redux";
import { AnonymousToMobileAccount, enterOTP, signOut } from "../../firebase";
import { chevronBack } from "ionicons/icons";
import { Button } from "@material-ui/core";
import { CutsomButtom } from "../CustomComponents/CustomButton";
import { signInWithPhoneNumber } from "../../firebase";
import { phoneAuth } from "../../Store/Actions";
import { ToastMessage } from "../../utils/toastMessage";
import { Loader } from "../../utils/loader";
import { checkMediaQuery } from "../../utils";

interface OtpScreenState {
  enteredOtp?: Array<string>;
  isError?: boolean;
  errorMessage?: string;
  uiChange?: any;
  setLogin?: Function;
  updateOnBoarding?: Function;
  ModifyToken?: Function;
}

class OtpScreen extends React.Component<
  {
    result: { verificationId: string };
    mobileNumber: string;
    history: any;
    phoneAuth: any;
    uiChange: any;
    setLogin: () => null;
    updateOnBoarding: (value: Object) => null;
    modifyToken: (value: Object) => null;
  },
  OtpScreenState
> {
  timer = null;
  state = {
    enteredOtp: ["", "", "", "", "", ""],
    isError: false,
    errorMessage: "",
    counter: 60,
    showToast: false,
    toastMessage: "",
    severity: "",
    loader: false,
    disabled: false,
  };

  componentDidMount() {
    if (!this.props.uiChange) {
      if (
        (this.props.result && !this.props.result.verificationId) ||
        !this.props.result ||
        !this.props.mobileNumber
      ) {
        this.props.history.push("/login");
      }
      if (this.props.result && this.props.result.verificationId) {
        this.runCounter();
      }
    } else {
      if (this.props.result && this.props.result.verificationId) {
        this.runCounter();
      }
    }
  }

  reEnterMobileNo() {
    if (!this.props.uiChange) {
      this.props.result.verificationId = "";
      this.props.history.goBack();
    }
  }

  runCounter = () => {
    if (this.state.counter >= 0) {
      this.timer = setInterval(
        () => this.setState({ counter: this.state.counter - 1 } as any),
        1000,
      ) as any;
    } else {
      clearInterval(this.timer as any);
    }
  };

  componentDidUpdate(prevProps: any) {
    if (!this.props.uiChange) {
      const { result = {}, mobileNumber = "" } = prevProps;
      if (this.props.mobileNumber !== mobileNumber || !Object.keys(result).length) {
        this.props.history.push("/login");
      }
    }
    if (this.state.counter <= 0) {
      clearInterval(this.timer as any);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer as any);
    this.setState({
      loader: false,
    } as any);
  }

  changeOtpValue = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const { enteredOtp } = this.state;
    const value = event.target.value;
    if (value.length <= 1 && (/^\d+$/.test(value) || !value)) {
      this.setState(
        {
          enteredOtp: [...enteredOtp.slice(0, index), value, ...enteredOtp.slice(index + 1)],
        },
        () => {
          if (index === 5 && this.state.enteredOtp.every((ele) => ele)) {
            this.submit();
          }
        },
      );
      if (index !== 5 && !!value) {
        (this as any)[`textInput${index + 1}`].focus();
      }
    }
  };

  onKeyPress = (index: number) => (event: any) => {
    const { enteredOtp } = this.state;
    // if (nativeEvent.key === "Backspace") {
    //   if (!enteredOtp[index] && !!index) {
    //     (this as any)[`textInput${index - 1}`].focus();
    //   }
    // }
  };

  onResendOTP = async () => {
    this.setState({
      loader: true,
    } as any);
    const result = await signInWithPhoneNumber("+971" + this.props.mobileNumber);
    const mobNum = this.props.mobileNumber;
    if (result && typeof result === "object") {
      this.props.phoneAuth({ result, mobNum });
      this.setState({
        loader: false,
        counter: 60,
        enteredOtp: ["", "", "", "", "", ""],
      } as any);
      this.runCounter();
    } else {
      this.formatError(result);
    }
  };

  formatError = (error: any) => {
    // console.log("Error ...... 160", error);
    if (error.includes("auth/")) {
      const splitted = error.split("/");
      if (splitted && splitted.length === 2) {
        let toastText = splitted[1].split("-").join(" ");
        this.setState({
          loader: false,
          showToast: true,
          toastMessage: toastText[0].toUpperCase() + toastText.slice(1).toLowerCase(),
          severity: "danger",
          disabled: false,
        } as any);
        return;
      }
    }
  };

  submit = async () => {
    const otp: string = this.state.enteredOtp.join("");
    const { result }: any = this.props;
    if (otp.length === 6) {
      this.setState({
        disabled: true,
        loader: true,
      } as any);
      const response = this.props.uiChange
        ? await AnonymousToMobileAccount(result, otp)
        : await enterOTP(result, otp);
      if (typeof response === "string") {
        this.formatError(response);
        return;
      }
      // this.setState({
      //   loader: true,
      // } as any);
      // if (!!response) {
      //   navigation.state.params.isValidated();
      //   navigation.goBack();
      // }
      if (this.props.uiChange) {
        this.setState({
          toastMessage: "Account created successfully",
          showToast: true,
          severity: "success",
        } as any);
        setTimeout(async () => {
          this.props.setLogin();
          await this.props.updateOnBoarding({ isAnonymous: false });
          await this.props.modifyToken({
            token: response.token,
            email: response.email || "",
            profileImagePath: response.photoURL || "",
            primaryPhoneNumber: response.phoneNumber || "",
          });
        }, 1000);
      }
    } else {
      this.setState({
        toastMessage: PLEASE_ENTER_VALID_OTP_NUMBER,
        showToast: true,
        severity: "warning",
      } as any);
    }
  };

  handleKeypress = (e: any) => {
    if (e.key === "Enter") {
      this.submit();
    }
  };

  render() {
    return (
      <>
        <div className="login15 get_start">
          {!this.props.uiChange && (
            <div
              className="getstarted_otp_mobile"
              style={isPlatform("ios") ? { marginTop: 15 } : {}}
            >
              <IonIcon
                icon={chevronBack}
                onClick={() => this.props.history.goBack()}
                color="tertiary"
              />
              <IonLabel className="getstartedtext_mobilenum">Get Started</IonLabel>
            </div>
          )}
          {!!this.props.uiChange ? (
            <div className="loginheader">
              <img
                src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
                className="back_arrow"
                onClick={() => (this.props as any).setLogin()}
              />
              <IonLabel className={"login17 displayblock"} color="secondary">
                {LOGIN_OR_SIGNUP}
              </IonLabel>
              <div />
            </div>
          ) : (
            <IonLabel className="login17">{LOGIN_OR_SIGNUP}</IonLabel>
          )}
          <div className="otplogin18">
            <IonLabel className="login19">{ENTER_SIX_DIGIT_OTP}</IonLabel>
            <div className="otpFields">
              {new Array(6).fill(0).map((ele, index) => (
                <input
                  type="tel"
                  value={this.state.enteredOtp[index]}
                  onChange={this.changeOtpValue(index)}
                  key={index}
                  className="otpInputs"
                  ref={(ele) => ((this as any)[`textInput${index}`] = ele)}
                  onKeyPress={(e) => this.handleKeypress(e)}
                />
              ))}
            </div>
            {this.state.counter > 0 ? (
              <IonLabel className="resetOtpText" color="tertiary">
                {RESEND_OTP_IN} <span className="timerText">: {this.state.counter}s</span>
              </IonLabel>
            ) : (
              // <IonButton
              //   className="otp_resend_button"
              //   onClick={() => this.onResendOTP()}
              // >
              <IonLabel
                color="primary"
                className="otp_resend_button"
                onClick={() => this.onResendOTP()}
              >
                {RESEND_OTP}
              </IonLabel>
              // </IonButton>
            )}
            <div className="login24" onClick={() => this.submit()}>
              <IonButton className="login25" disabled={this.state.disabled}>
                {CONTINUE}
              </IonButton>
            </div>
            {!this.props.uiChange && (
              <div>
                <div className="otplogin24" onClick={() => this.submit()}>
                  <IonButton className="otplogin25" disabled={this.state.disabled}>
                    {SUBMIT}
                  </IonButton>
                </div>

                <div className="otplogin24">
                  <IonLabel
                    className="reEnterMobileNo cursor_pointer"
                    onClick={() => this.reEnterMobileNo()}
                  >
                    {REENTER_MOBILE_NO}
                  </IonLabel>
                </div>
              </div>
            )}
            <div className="otpSentText">
              <IonLabel className="otpEnterText">
                {`A One Time Password (OTP) has been sent to +971 ${
                  (this.props.mobileNumber || "").slice(0, 1) +
                  "******" +
                  (this.props.mobileNumber || "").slice(8, 10)
                }, Please enter it`}
              </IonLabel>
            </div>
          </div>
          <ToastMessage
            showToast={this.state.showToast}
            ToastMessage={this.state.toastMessage}
            severity={this.state.severity}
            onDidDismiss={() => {
              this.setState({
                showToast: !this.state.showToast,
                ToastMessage: "",
                severity: "",
              } as any);
            }}
          />
          {this.state.loader ? <Loader loader={this.state.loader} /> : null}
        </div>
      </>
    );
  }
}

export default connect(
  ({ auth: { result, mobileNumber } }: any) => {
    return { result, mobileNumber };
  },
  { phoneAuth },
)(OtpScreen);
